import { FiHeadphones, FiMail } from 'react-icons/fi';
import { siteContent } from '../../data/siteContent';
import Card from '../card/Card';

const ContactOne = () => {
  return (
    <>
      <div className="mt--40">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '30px',
            alignItems: 'stretch',
          }}
        >
          <Card title="Contact Phone Numbers" icon={FiHeadphones}>
            <div>
              <a href="https://wa.me/79174531267">
                WhatsApp: +7 917 453 12 67{' '}
              </a>
            </div>
            <div>
              <a href="tel:+62 812 3 999 3502">Phone: +62 812 3 999 3502</a>
            </div>
          </Card>

          <Card title="My Email Address" icon={FiMail}>
            <div>
              <a href="mailto:nigmatullinaregina@gmail.com">
                nigmatullinaregina@gmail.com
              </a>
            </div>
          </Card>
        </div>

        <div className="contact-cta mt--40 flex justify-center items-center text-center">
          <a
            className="btn-default btn-large round btn-icon"
            href={siteContent.links.calendly}
            target="_blank"
            rel="noreferrer"
          >
            Book a Call
          </a>
        </div>
      </div>
    </>
  );
};

export default ContactOne;
